







































































import Modal from "../core/Modals/Modal.vue";
import { Contact } from "../models/Contact";
import ContactSelect from "../core/Forms/ContactSelect.vue";
import HtmlTextareaInput from "../core/Forms/HtmlTextareaInput.vue";
import { JournalEntry } from "../models/JournalEntry";
import { JournalApi } from "../api/JournalApi";
import { EmailApi } from "../api/EmailApi";
import MailEditor from "../core/Forms/MailEditor.vue";
import FileUploader from "../core/Forms/FileUploader.vue";
import JournalObjectSelect from "../core/Forms/JournalObjectSelect.vue";
import StringUtils from "../utils/StringUtils";
import { SettingApi } from "../api/SettingApi";
import { Setting } from "../models/Setting";
import { entries, set } from "lodash";
import moment from "moment";

// Formule d'appel des mails de relance : les modèles sont rédigés au neutre
// (« Madame, Monsieur, ») et l'opérateur peut basculer sur « Madame, » ou
// « Monsieur, » quand il connaît son interlocuteur. La bascule réécrit le
// texte courant (retouches conservées). Même règle que switchCivilite() dans
// resources/assets/react/relance_clients_v3/relance_clients_v3.jsx (popup courrier).
const CIVILITES = [
    { key: "neutre", label: "Madame, Monsieur" },
    { key: "madame", label: "Madame" },
    { key: "monsieur", label: "Monsieur" },
];
const civiliteLabel = (key: string): string =>
    (CIVILITES.find((c) => c.key === key) || CIVILITES[0]).label;
export const switchCivilite = (
    text: string,
    from: string,
    to: string
): string => {
    const t = String(text == null ? "" : text);
    if (from === to) return t;
    const neutre = civiliteLabel("neutre") + ",";
    const target = civiliteLabel(to) + ",";
    if (from === "neutre") return t.split(neutre).join(target);
    // « Madame, » est un préfixe de « Madame, Monsieur, » : on protège la
    // forme neutre (tapée à la main) avant de remplacer la forme courante.
    const PH = "\u0000";
    return t
        .split(neutre)
        .join(PH)
        .split(civiliteLabel(from) + ",")
        .join(target)
        .split(PH)
        .join(neutre);
};

export default {
    name: "SendEmailModal",
    components: {
        JournalObjectSelect,
        MailEditor,
        FileUploader,
        HtmlTextareaInput,
        ContactSelect,
        Modal,
    },
    props: {
        showModal: Boolean,
        parentId: Number,
        forwardedFiles: Array,
        availableFiles: Array,
        defaultSubject: String,
        defaultMessage: String,
        defaultFooter: String,
        defaultContact: Contact,
        defaultTo: String,
        useRelanceDefaultBcc: Boolean,
        createJournalEntry: {
            type: Boolean,
            default: true,
        },
        useDefaultTemplate: {
            type: Boolean,
            default: true,
        },
        // Dossiers journal auxquels rattacher le Mail envoyé ; le serveur
        // suffixe alors le sujet avec " - ref:<référence>" (rattachement
        // automatique des réponses par cron:journal:mail).
        journalEntryIds: {
            type: Array,
            default: () => [],
        },
        // Sélecteur « Madame, Monsieur / Madame / Monsieur » au-dessus du
        // message : réservé aux mails de relance (directive relance_clients_v3).
        civiliteSelector: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            civilites: CIVILITES,
            civilite: "neutre",
            entryParentId: null,
            selectedObject: null,
            emailData: {
                to: "",
                subject: "",
                body: "",
                attachments: [],
                photos: [],
            },
            SettingApi: new SettingApi(),
            JournalApi: new JournalApi(),
            EmailApi: new EmailApi(),
            saving: false,
        };
    },
    created() {
        this.generateEmailBody();
    },
    methods: {
        generateEmailBody() {
            let self = this;

            if (!self.useDefaultTemplate) {
                let body = self.defaultMessage || "";

                if (self.defaultFooter) {
                    body += "<hr>" + self.defaultFooter;
                }

                self.emailData.body = body;
                return;
            }

            self.SettingApi.get(Setting.settingsKeys.mail_template).then(
                function (setting) {
                    let body = setting.value;

                    body = _.replace(
                        body,
                        "{full_date}",
                        moment().format("Do MMMM YYYY")
                    );

                    if (self.defaultMessage) {
                        body = _.replace(
                            body,
                            "{mail_body}",
                            self.defaultMessage
                        );
                    } else {
                        body = _.replace(body, "{mail_body}", "");
                    }

                    if (self.defaultFooter) {
                        body += "<hr>" + self.defaultFooter;
                    }

                    self.emailData.body = body;
                }
            );
        },
        // Events
        closeModal(isSaved: boolean, sentData?: object): void {
            this.saving = false;
            this.$emit("close-modal", isSaved, sentData);
        },
        updateFilesList: function (filesIds: Array<Number>): void {
            this.emailData.attachments = filesIds;
        },
        updatePhotosList: function (photoIds: Array<Number>): void {
            this.emailData.photos = photoIds;
        },
        onUploadStart: function () {
            this.saving = true;
        },
        onUploadEnd: function () {
            this.saving = false;
        },
        setCivilite(to: string): void {
            this.emailData.body = switchCivilite(
                this.emailData.body,
                this.civilite,
                to
            );
            this.civilite = to;
        },
        updateMailData: function (emailData) {
            this.emailData.to = emailData.to;
            this.emailData.subject = emailData.subject;
            this.emailData.body = emailData.body;
            this.emailData.recipient = emailData.recipient;
        },
        // Save
        saveData: function (): void {
            let self = this;

            if (
                !self.emailData.to ||
                !StringUtils.isValidEmailList(self.emailData.to) ||
                self.saving
            )
                return;

            self.saving = true;

            const payload = Object.assign({}, self.emailData, {
                use_relance_default_bcc: self.useRelanceDefaultBcc
                    ? 1
                    : undefined,
                // Chaîne JSON attendue : le serveur fait json_decode().
                journal_entry_ids:
                    self.journalEntryIds && self.journalEntryIds.length
                        ? JSON.stringify(self.journalEntryIds)
                        : undefined,
            });

            self.EmailApi.create(payload).then(function (res) {
                // Le contenu réellement envoyé est renvoyé au parent (les
                // relances l'archivent dans le dossier de suivi), avec l'id
                // du Mail persisté pour le rattacher au commentaire.
                const sentData = {
                    to: self.emailData.to,
                    subject: self.emailData.subject,
                    body: self.emailData.body,
                    mail_id:
                        res && res.data && res.data.data
                            ? res.data.data.id
                            : null,
                };

                if (!self.createJournalEntry) {
                    self.closeModal(true, sentData);
                    return;
                }

                let newNotification = JournalEntry.createFromEmailData(
                    self.emailData,
                    self.entryParentId
                );

                return self.JournalApi.save(newNotification).then(function (
                    res
                ) {
                    self.closeModal(true, sentData);
                });
            });
        },
    },
    watch: {
        parentId: {
            immediate: true,
            handler: function () {
                if (this.parentId) {
                    this.entryParentId = this.parentId;
                }
            },
        },
        defaultMessage: {
            immediate: true,
            handler: function () {
                if (this.defaultMessage) {
                    this.generateEmailBody();
                }
            },
        },
        defaultFooter: {
            immediate: true,
            handler: function () {
                if (this.defaultFooter) {
                    this.generateEmailBody();
                }
            },
        },
        defaultSubject: {
            immediate: true,
            handler: function () {
                if (this.defaultSubject) {
                    this.emailData.subject = this.defaultSubject;
                }
            },
        },
        defaultTo: {
            immediate: true,
            handler: function () {
                if (this.defaultTo) {
                    this.emailData.to = this.defaultTo;
                }
            },
        },
        showModal: {
            immediate: true,
            handler: function () {
                if (!this.showModal) {
                    this.filesIds = [];
                } else if (this.defaultTo) {
                    this.emailData.to = this.defaultTo;
                }
                // Le texte repart du modèle (au neutre) à chaque ouverture.
                this.civilite = "neutre";
                this.generateEmailBody();
            },
        },
    },
};
